import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { v4 } from "uuid";
import InfoActionPage from "../../Components/InfoActionPage";
import Layout from "../../Components/Layout";
import Api from "../../Server/Api";
import CallTools from "./CallTools";

const api = new Api();

const defaultMsg = {
	title: "Unable to Connect",
	message: `Thank you for submitting your medical record form for easy accessment, one of our doctors will contact you shortly. `,
	image: require("../../assets/img/undraw_remote_meeting_re_abe7.svg").default,
	action: {
		text: "Back to Dashboard",
		action: () => {
			window.location = "/dashboard";
		},
	},
};

const VideoCall = ({ user }) => {
	const { meeting_id } = useParams();
	const [message, setMessage] = useState();
	const [loading, setLoading] = useState(true);
	const [meeting, setMeeting] = useState();

	const config = {
		name:
			user?.role === "SPECIALIST" ? `${user?.title} ${user?.name}` : user?.name,
		apiKey: "50579e55-ea28-4be2-8d4b-ac4f9910aa52",
		meetingId: meeting_id,
		redirectOnLeave: "https://evokeeclinic.com/dashboard/",
		micEnabled: true,
		webcamEnabled: true,
		participantCanToggleSelfWebcam: true,
		participantCanToggleSelfMic: true,
		joinScreen: {
			visible: true, // Show the join screen ?
			title: "24Telemed Doctor Meeting", // Meeting title
			meetingUrl: window.location.href, // Meeting joining url
		},
	};

	const startMeeting = async () => {
		const res = await api.get({
			endpoint: `/appointments/${meeting_id}/start_meeting/`,
		});
		if (res?.status) {
			setMeeting(res?.data);
			// eslint-disable-next-line no-undef
			const vc = new VideoSDKMeeting();
			vc.init(config);
			setLoading(false);
			return;
		}
		setLoading(false);
		setMessage({
			...defaultMsg,
			message: res?.detail || "Unable to start meeting at this time.",
		});
	};

	useEffect(() => {
		startMeeting();
	}, []);

	const isMobile = window.innerWidth < 900;

	return (
		<Layout sidePanel={true} title={"Live Call"}>
			{(loading && (
				<div
					className="has-loader has-loader-active"
					style={{ minHeight: 700, width: "100%" }}
				>
					<div className="h-loader-wrapper" style={{ flexDirection: "column" }}>
						<div className="loader is-small is-loading mb-3" />
						<h3>Connecting, please wait...</h3>
					</div>
				</div>
			)) || <>{message && <InfoActionPage {...message} />}</>}
			<style>
				{`
					iframe {
						left: ${isMobile ? 0 : 80}px !important;
						width: calc(100% - ${isMobile ? 0 : 80}px) !important;
						right: 0 !important;
						position: absolute !important;
					}

					.page-content-inner {
						position: absolute !important;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						min-height: 100vh;
					}

				`}
			</style>
			<CallTools 
				config={config} 
				meeting={meeting}
				isDoctor={user?.role === "SPECIALIST"}
			/>
		</Layout>
	);
};

const mapStateToProps = ({ user }) => {
	return { user: user.user };
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoCall);
